import React, { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

// Register the required components
ChartJS.register(
  BarElement,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend
);

const MultiReportChart = ({ chartData }) => {
  const data = {
    labels: ["M", "T", "W", "T", "F", "S", "S"],
    datasets: [
      {
        label: "Dataset 1",
        backgroundColor: "rgba(54, 162, 235, 0.8)",
        data: [250, 500, 750, 400, 600, 300, 350],
      },
      {
        label: "Dataset 2",
        backgroundColor: "rgba(201, 203, 207, 0.5)",
        data: [200, 400, 700, 300, 500, 250, 320],
      },

      {
        label: "Dataset 3",
        backgroundColor: "rgba(100, 50, 89, 0.7)",
        data: [150, 300, 560, 300, 560, 250, 320],
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
    },
    scales: {
      y: {
        beginAtZero: true,
      },
    },
  };

  return <Bar data={chartData} options={options} />;
};

export default MultiReportChart;
